import template from './template.html';

export default angular.module('ModalDialog', [])

    .service('ModalDialogService', ['$uibModal', '$state', function ($uibModal, $state) {

        this.active = true;
        this.isModalClosed = true;

        this.open = function () {

            if (this.isModalClosed == true && this.active == true) {
                this.modalOpened();
                this.modalInstance = $uibModal.open({
                    animation: false,
                    template: template,
                    controller: 'ModalDialogController as ctrl',
                    size: 'lg',
                    backdrop: false,
                });

                this.modalInstance.closed.then(() => {

                    //handle ui close event here
                    this.modalClosed();

                });

                return this.modalInstance.result;
            }

        };

        this.modalClosed = () => {
            this.isModalClosed = true;
        };

        this.modalOpened = () => {
            this.isModalClosed = false;
        };

        this.setActive = () => {
            this.active = true;
        };

        this.setInactive = () => {
            this.active = false;
            this.dismissModal();
        };

        this.dismissModal = () => {
            if (this.modalInstance && this.active == false) {
                this.modalInstance.dismiss();
            }
        };

        this.saveLastRelevantRequestFromServer = (requestConfig) => {
            this.requestConfig = requestConfig;
        };

        this.getLastRelevantRequestFromServer = () => {
            return this.requestConfig;
        };

    }])

    .controller('ModalDialogController', [
        '$rootScope', '$scope', '$uibModalInstance', 'ApiPanelsService', '$state', 'ModalDialogService', '$stateParams', '$http',
        ($rootScope, $scope, $uibModalInstance, ApiPanelsService, $state, ModalDialogService, $stateParams, $http,) => {

            $scope.remoteAccessPassword = angular.copy($rootScope.remoteAccessPassword);
            $scope.userCode = ApiPanelsService.getUserCode();
            $scope.currentUserId = $stateParams.id;

            ApiPanelsService.getPanelById($scope.currentUserId).then(r => {
                $scope.mac = r.data.control_panel.mac
            });

            $scope.reload = () => {
                let config = ModalDialogService.getLastRelevantRequestFromServer();
                if(config) {
                    config.headers['X-Crow-CP-Remote'] = $scope.remoteAccessPassword;
                    config.headers['X-Crow-CP-User'] = $scope.userCode;
                    $http(config);
                }
                ApiPanelsService.setHttpHeaders($scope.remoteAccessPassword, $scope.userCode);

                if ($scope.isConfirmed) {
                    ApiPanelsService.saveRemoteAccessPasswordAndUserCode($scope.currentUserId,
                        $scope.remoteAccessPassword,
                        $scope.userCode,
                        $scope.mac);
                }
                $uibModalInstance.dismiss('connect');
            };

            $scope.onCancelPushed = () => {

                $uibModalInstance.dismiss('cancel');
                $scope.navigateTo();
            };

            $scope.navigateTo = () => {

                if (ApiPanelsService.isMoreThenOnePanel()) {
                    $state.go('main.panels');
                }
                else {
                    $state.go('login');
                }
            };

            $scope.rememberMe = (confirmed) => {
                $scope.isConfirmed = confirmed;
            };


        }])

    .name;


/** WEBPACK FOOTER **
 ** ./src/components/wrongCredentialsModal/index.js
 **/